/**
 * Helpers for GET users/:id/following payloads.
 *
 * Backend now returns a polymorphic list:
 *   [{ type: 'User', user }, { type: 'Business', business }, { type: 'Charity', charity }]
 * Older responses were a flat array of user objects. Support both.
 */

export function followingUserIdsFromPayload(data) {
  if (!Array.isArray(data)) return []

  return data
    .map(item => {
      if (item?.type === 'User' && item.user?.id != null) return item.user.id
      if (item?.type === 'Business' || item?.type === 'Charity') return null
      // Legacy flat user shape (no type discriminator)
      if (item?.id != null && item?.type == null) return item.id
      return null
    })
    .filter(id => id != null)
}

export function followingUserIdSetFromPayload(data) {
  return new Set(followingUserIdsFromPayload(data))
}
